import {JiraTicket, JiraTicketTabId} from 'views/home/dashboard/dashboardModel';

export const ASSIGNED_TAB_ID: JiraTicketTabId = 'assigned';
export const CREATED_TAB_ID: JiraTicketTabId = 'created';

export const filterJiraTicketsForTab = (
  tickets: JiraTicket[],
  tabId: JiraTicketTabId
): JiraTicket[] =>
  tabId === ASSIGNED_TAB_ID
    ? tickets.filter((ticket) => ticket.isAssignedToViewer)
    : tickets.filter((ticket) => ticket.isReportedByViewer);

export const countJiraTicketsForTab = (tickets: JiraTicket[], tabId: JiraTicketTabId): number =>
  filterJiraTicketsForTab(tickets, tabId).length;

/** Show Assigned/Created tabs only when both cohorts have tickets to show. */
export const shouldShowJiraTabs = (tickets: JiraTicket[]): boolean =>
  countJiraTicketsForTab(tickets, ASSIGNED_TAB_ID) > 0 &&
  countJiraTicketsForTab(tickets, CREATED_TAB_ID) > 0;

/**
 * Pick the tab to open on. Honors the viewer's preference when that cohort has
 * tickets, otherwise falls back to whichever cohort is non-empty.
 */
export const getDefaultJiraTab = (
  tickets: JiraTicket[],
  preferred: JiraTicketTabId = ASSIGNED_TAB_ID
): JiraTicketTabId => {
  if (countJiraTicketsForTab(tickets, preferred) > 0) {
    return preferred;
  }
  return countJiraTicketsForTab(tickets, ASSIGNED_TAB_ID) > 0 ? ASSIGNED_TAB_ID : CREATED_TAB_ID;
};
